import React from 'react';
import { Grid } from '@mui/material';
import { dropStatusDocumento } from 'utils/drops';
import Input from 'components/Input';
import InputMask from 'components/InputMask';
import VirtualDrop from 'components/VirtualDrop';
import Dropdown from 'components/Dropdown';

const Filter = ({ grid, control, drops }) => {
  const checkDisplay = (name) => {
    const column = grid?.colunas?.find((c) => c?.field === name);
    if (column?.filterable) {
      return true;
    }
    return false;
  };

  return (
    <Grid container spacing={2}>
      {checkDisplay('id') && (
        <Grid item xs={12}>
          <Input name="id" control={control} label="ID" type="number" />
        </Grid>
      )}
      {checkDisplay('status') && (
        <Grid item xs={12}>
          <Dropdown
            name="status"
            control={control}
            label="Status"
            options={dropStatusDocumento}
            multiple
          />
        </Grid>
      )}
      {checkDisplay('entidade') && (
        <Grid item xs={12}>
          <VirtualDrop
            name="entidade"
            control={control}
            label="Entidade"
            options={drops?.Entidade}
            multiple
          />
        </Grid>
      )}
      {checkDisplay('contrato') && (
        <Grid item xs={12}>
          <Input name="contrato" control={control} label="Contrato" />
        </Grid>
      )}
      {checkDisplay('vldocto') && (
        <Grid item xs={12}>
          <InputMask name="vldocto" control={control} label="Valor" />
        </Grid>
      )}
      {checkDisplay('dia_pagto') && (
        <Grid item xs={12}>
          <Input name="dia_pagto" control={control} label="Dia de Pagamento" />
        </Grid>
      )}
      {checkDisplay('forma_pagto') && (
        <Grid item xs={12}>
          <Dropdown
            name="forma_pagto"
            control={control}
            label="Forma de Pagamento"
            options={drops?.FormaDePagamento?.filter(
              (f) => f?.modulo !== 'COMPRAS' && f?.modulo !== 'CHEQUES'
            )}
            multiple
          />
        </Grid>
      )}
      {checkDisplay('ultimo_faturamento') && (
        <Grid item xs={6}>
          <InputMask
            name="ultimo_faturamento.i"
            control={control}
            label="Último Faturamento Inicial"
            type="date"
          />
        </Grid>
      )}
      {checkDisplay('ultimo_faturamento') && (
        <Grid item xs={6}>
          <InputMask
            name="ultimo_faturamento.f"
            control={control}
            label="Último Faturamento Final"
            type="date"
          />
        </Grid>
      )}
      {checkDisplay('proximo_faturamento') && (
        <Grid item xs={6}>
          <InputMask
            name="proximo_faturamento.i"
            control={control}
            label="Próximo Faturamento Inicial"
            type="date"
          />
        </Grid>
      )}
      {checkDisplay('proximo_faturamento') && (
        <Grid item xs={6}>
          <InputMask
            name="proximo_faturamento.f"
            control={control}
            label="Próximo Faturamento Final"
            type="date"
          />
        </Grid>
      )}
    </Grid>
  );
};

export default Filter;
